import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDocumentUpload } from 'Core/hooks';
import CustomPropTypes from 'CustomPropTypes';
import { downloadImage } from 'Core/utils';
import Alert from 'react-bootstrap/Alert';

const styles = {
  uploadContainer: {
    background: 'white',
    borderRadius: '4px',
    padding: '15px',
  },
  uploadArea: {
    marginBottom: '15px',
  },
  uploadLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '120px',
    border: '2px dashed #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9',
    transition: 'background-color 0.2s',
  },
  uploadContent: {
    textAlign: 'center',
  },
  uploadIcon: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '8px',
  },
  uploadText: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '4px',
  },
  uploadBold: {
    fontWeight: 600,
  },
  uploadSubtext: {
    fontSize: '12px',
    color: '#888',
  },
  hiddenInput: {
    display: 'none',
  },
  previewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: '15px',
    marginTop: '15px',
  },
  previewItem: {
    position: 'relative',
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  previewImageContainer: {
    position: 'relative',
    paddingTop: '75%' /* 4:3 Aspect Ratio */,
  },
  previewImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  removeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#ff4444',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  fileName: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: '6px 8px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

const initData = {
  id: 0,
  InspectionResultsId: 0,
  fileName: '',
  filePath: '',
  relativePath: '',
};

const InspectionOverview = ({ data, onAction, onCommentUpdate, key }) => {
  const [toolFilesInputs, setToolFileInputs] = useState(initData);
  const [toolFiles, setToolFiles] = useState(data);
  const updateToolFileField = (field, value) => {
    setToolFileInputs(prevToolFileInputs => ({
      ...prevToolFileInputs,
      [field]: value,
    }));
  };

  const { uploadDocuments, loading } = useDocumentUpload();
  const [isHovering, setIsHovering] = useState(false);

  const handleFileUpload = async event => {
    const files = Array.from(event.target.files);

    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('UploadCategory', 'Inspection-InspectionOverview');

    const result = await uploadDocuments(formData);
    if (result) {
      const newFile = {
        id: Math.floor(Math.random() * 101),
        fileName: result.fileName,
        filePath: result.filePath,
        relativePath: result.relativePath,
      };
      const newFiles = [...toolFiles, newFile];

      setToolFiles(newFiles);
      setToolFileInputs(initData);
    }
  };

  const downloadImageFn = (e, img) => {
    e.stopPropagation();
    downloadImage(img);
  };

  const removeFile = fileId => {
    const newFiles = toolFiles.filter(toolFile => toolFiles.id !== fileId);
    setToolFiles(newFiles);
  };

  return (
    <>
      <div className=" w-100 d-flex row justify-content-between flex-row">
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'info'} variant={'info'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Cycle Time</label>
              <h3>{data.cycleTime}</h3>
            </div>
          </Alert>
        </div>
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'success'} variant={'success'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Part Weight</label>
              <h3>{data.partWeight}</h3>
            </div>
          </Alert>
        </div>
      </div>
      <div className=" w-100 d-flex row justify-content-between flex-row">
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'warning'} variant={'warning'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Scrap# (24 hrs)</label>
              <h3>{data.scrapNumber24Hours}</h3>
            </div>
          </Alert>
        </div>
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'warning'} variant={'warning'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Scrap Rate (24 hrs)</label>
              <h3>{data.scrapRate24Hours}</h3>
            </div>
          </Alert>
        </div>
      </div>
      <div className=" w-100 d-flex row justify-content-between flex-row">
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'danger'} variant={'danger'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Scrap# (Total Production/Workticket)</label>
              <h3>{data.totalScrap}</h3>
            </div>
          </Alert>
        </div>
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'danger'} variant={'danger'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Scrap Rate (Total Production/Workticket)</label>
              <h3>{data.scrapRate}</h3>
            </div>
          </Alert>
        </div>
      </div>
      <div className=" w-100 d-flex row justify-content-between flex-row">
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'secondary'} variant={'secondary'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Total AQL Completed</label>
              <label>(Total Production/Workticket)</label>
              <h3>{data.totalAQLCompleted}</h3>
            </div>
          </Alert>
        </div>
        <div className="mb-4 col-12 col-lg-6">
          <Alert className="h-100px mb-0 w-100 p-3" key={'secondary'} variant={'secondary'}>
            <div className="d-flex flex-column">
              <label className="mb-1">Quality Inspection</label>
              <label>(Total Production/Workticket)</label>
              <h3>{data.totalQCCompleted}</h3>
            </div>
          </Alert>
        </div>
      </div>
    </>
  );
};

InspectionOverview.defaultProps = {
  onAction: () => {},
  data: [],
};

InspectionOverview.propTypes = {
  onAction: PropTypes.func,
  data: PropTypes.shape(CustomPropTypes.InspectionResults),
};

export default InspectionOverview;
